import { TranslocoService } from '@jsverse/transloco';

import { shUseTranslation } from '@shure/shared/angular/utils/i18n';

/* Labels defined for AgGrid */
type AgGridLabelKey =
	| 'addCurrentSelectionToFilter'
	| 'addToLabels'
	| 'addToValues'
	| 'advancedFilterAnd'
	| 'advancedFilterApply'
	| 'advancedFilterBlank'
	| 'advancedFilterBuilder'
	| 'advancedFilterBuilderAddButtonTooltip'
	| 'advancedFilterBuilderAddCondition'
	| 'advancedFilterBuilderAddJoin'
	| 'advancedFilterBuilderApply'
	| 'advancedFilterBuilderCancel'
	| 'advancedFilterBuilderEnterValue'
	| 'advancedFilterBuilderMoveDownButtonTooltip'
	| 'advancedFilterBuilderMoveUpButtonTooltip'
	| 'advancedFilterBuilderRemoveButtonTooltip'
	| 'advancedFilterBuilderSelectColumn'
	| 'advancedFilterBuilderSelectOption'
	| 'advancedFilterBuilderTitle'
	| 'advancedFilterBuilderValidationAlreadyApplied'
	| 'advancedFilterBuilderValidationEnterValue'
	| 'advancedFilterBuilderValidationIncomplete'
	| 'advancedFilterBuilderValidationSelectColumn'
	| 'advancedFilterBuilderValidationSelectOption'
	| 'advancedFilterContains'
	| 'advancedFilterEndsWith'
	| 'advancedFilterEquals'
	| 'advancedFilterFalse'
	| 'advancedFilterGreaterThan'
	| 'advancedFilterGreaterThanOrEqual'
	| 'advancedFilterLessThan'
	| 'advancedFilterLessThanOrEqual'
	| 'advancedFilterNotBlank'
	| 'advancedFilterNotContains'
	| 'advancedFilterNotEqual'
	| 'advancedFilterOr'
	| 'advancedFilterStartsWith'
	| 'advancedFilterTextEquals'
	| 'advancedFilterTextNotEqual'
	| 'advancedFilterTrue'
	| 'advancedFilterValidationExtraEndBracket'
	| 'advancedFilterValidationInvalidColumn'
	| 'advancedFilterValidationInvalidDate'
	| 'advancedFilterValidationInvalidJoinOperator'
	| 'advancedFilterValidationInvalidOption'
	| 'advancedFilterValidationJoinOperatorMismatch'
	| 'advancedFilterValidationMessage'
	| 'advancedFilterValidationMessageAtEnd'
	| 'advancedFilterValidationMissingColumn'
	| 'advancedFilterValidationMissingCondition'
	| 'advancedFilterValidationMissingEndBracket'
	| 'advancedFilterValidationMissingOption'
	| 'advancedFilterValidationMissingQuote'
	| 'advancedFilterValidationMissingValue'
	| 'advancedFilterValidationNotANumber'
	| 'andCondition'
	| 'applyFilter'
	| 'april'
	| 'area'
	| 'areaChart'
	| 'AreaColumnCombo'
	| 'areaColumnComboTooltip'
	| 'areaGroup'
	| 'ariaAdvancedFilterBuilderColumn'
	| 'ariaAdvancedFilterBuilderFilterItem'
	| 'ariaAdvancedFilterBuilderGroupItem'
	| 'ariaAdvancedFilterBuilderItem'
	| 'ariaAdvancedFilterBuilderItemValidation'
	| 'ariaAdvancedFilterBuilderJoinOperator'
	| 'ariaAdvancedFilterBuilderList'
	| 'ariaAdvancedFilterBuilderOption'
	| 'ariaAdvancedFilterBuilderValueP'
	| 'ariaAdvancedFilterInput'
	| 'ariaChecked'
	| 'ariaColumn'
	| 'ariaColumnFiltered'
	| 'ariaColumnGroup'
	| 'ariaColumnList'
	| 'ariaColumnPanelList'
	| 'ariaColumnSelectAll'
	| 'ariaDateFilterInput'
	| 'ariaDefaultListName'
	| 'ariaDropZoneColumnComponentAggFuncSeparator'
	| 'ariaDropZoneColumnComponentDescription'
	| 'ariaDropZoneColumnComponentSortAscending'
	| 'ariaDropZoneColumnComponentSortDescending'
	| 'ariaDropZoneColumnGroupItemDescription'
	| 'ariaDropZoneColumnValueItemDescription'
	| 'ariaFilterColumn'
	| 'ariaFilterColumnsInput'
	| 'ariaFilterFromValue'
	| 'ariaFilteringOperator'
	| 'ariaFilterInput'
	| 'ariaFilterList'
	| 'ariaFilterMenuOpen'
	| 'ariaFilterPanelList'
	| 'ariaFilterToValue'
	| 'ariaFilterValue'
	| 'ariaHidden'
	| 'ariaIndeterminate'
	| 'ariaInputEditor'
	| 'ariaLabelAdvancedFilterAutocomplete'
	| 'ariaLabelAdvancedFilterBuilderAddField'
	| 'ariaLabelAdvancedFilterBuilderColumnSelectField'
	| 'ariaLabelAdvancedFilterBuilderJoinSelectField'
	| 'ariaLabelAdvancedFilterBuilderOptionSelectField'
	| 'ariaLabelAggregationFunction'
	| 'ariaLabelCellEditor'
	| 'ariaLabelColumnFilter'
	| 'ariaLabelColumnMenu'
	| 'ariaLabelContextMenu'
	| 'ariaLabelDialog'
	| 'ariaLabelRichSelectDeleteSelection'
	| 'ariaLabelRichSelectDeselectAllItems'
	| 'ariaLabelRichSelectField'
	| 'ariaLabelRichSelectToggleSelection'
	| 'ariaLabelSelectField'
	| 'ariaLabelSubMenu'
	| 'ariaLabelTooltip'
	| 'ariaMenuColumn'
	| 'ariaPageSizeSelectorLabel'
	| 'ariaPivotDropZonePanelLabel'
	| 'ariaRowDeselect'
	| 'ariaRowGroupDropZonePanelLabel'
	| 'ariaRowSelect'
	| 'ariaRowSelectAll'
	| 'ariaRowSelectionDisabled'
	| 'ariaRowToggleSelection'
	| 'ariaSearch'
	| 'ariaSearchFilterValues'
	| 'ariaSortableColumn'
	| 'ariaToggleCellValue'
	| 'ariaToggleVisibility'
	| 'ariaUnchecked'
	| 'ariaValuesDropZonePanelLabel'
	| 'ariaVisible'
	| 'august'
	| 'automatic'
	| 'autoRotate'
	| 'autosizeAllColumns'
	| 'autosizeThisColumn'
	| 'avg'
	| 'axis'
	| 'background'
	| 'barChart'
	| 'barGroup'
	| 'blank'
	| 'blanks'
	| 'blur'
	| 'bold'
	| 'boldItalic'
	| 'bottom'
	| 'bubble'
	| 'bubbleTooltip'
	| 'callout'
	| 'cancelFilter'
	| 'categories'
	| 'category'
	| 'chart'
	| 'chartDownloadToolbarTooltip'
	| 'chartLinkToolbarTooltip'
	| 'chartRange'
	| 'chartSettingsToolbarTooltip'
	| 'chartUnlinkToolbarTooltip'
	| 'chooseColumns'
	| 'clearFilter'
	| 'collapseAll'
	| 'color'
	| 'columnChart'
	| 'columnChooser'
	| 'columnGroup'
	| 'columnLineCombo'
	| 'columnLineComboTooltip'
	| 'columns'
	| 'combinationChart'
	| 'combinationGroup'
	| 'contains'
	| 'copy'
	| 'copyWithGroupHeaders'
	| 'copyWithHeaders'
	| 'count'
	| 'csvExport'
	| 'ctrlC'
	| 'ctrlV'
	| 'ctrlX'
	| 'customComboTooltip'
	| 'cut'
	| 'data'
	| 'dateFilter'
	| 'dateFormatOoo'
	| 'december'
	| 'decimalSeparator'
	| 'defaultCategory'
	| 'doughnut'
	| 'doughnutTooltip'
	| 'empty'
	| 'enabled'
	| 'endsWith'
	| 'equals'
	| 'excelExport'
	| 'expandAll'
	| 'export'
	| 'exportSelected'
	| 'false'
	| 'february'
	| 'fillOpacity'
	| 'filteredRows'
	| 'filterOoo'
	| 'filters'
	| 'first'
	| 'firstPage'
	| 'font'
	| 'format'
	| 'greaterThan'
	| 'greaterThanOrEqual'
	| 'group'
	| 'groupBy'
	| 'groupedAreaTooltip'
	| 'groupedBar'
	| 'groupedBarTooltip'
	| 'groupedColumn'
	| 'groupedColumnTooltip'
	| 'groupFilterSelect'
	| 'groups'
	| 'height'
	| 'histogramBinCount'
	| 'histogramChart'
	| 'histogramFrequency'
	| 'histogramGroup'
	| 'histogramTooltip'
	| 'inRange'
	| 'inRangeEnd'
	| 'inRangeStart'
	| 'invalidDate'
	| 'invalidNumber'
	| 'italic'
	| 'itemPaddingX'
	| 'itemPaddingY'
	| 'itemSpacing'
	| 'january'
	| 'july'
	| 'june'
	| 'labels'
	| 'last'
	| 'lastPage'
	| 'layoutHorizontalSpacing'
	| 'layoutVerticalSpacing'
	| 'left'
	| 'legend'
	| 'length'
	| 'lessThan'
	| 'lessThanOrEqual'
	| 'line'
	| 'lineDash'
	| 'lineGroup'
	| 'lineTooltip'
	| 'lineWidth'
	| 'loadingError'
	| 'loadingOoo'
	| 'march'
	| 'markerPadding'
	| 'markers'
	| 'markerSize'
	| 'markerStroke'
	| 'max'
	| 'maxSize'
	| 'may'
	| 'min'
	| 'minSize'
	| 'more'
	| 'navigator'
	| 'nextPage'
	| 'noAggregation'
	| 'noDataToChart'
	| 'noMatches'
	| 'none'
	| 'noPin'
	| 'normal'
	| 'normalizedArea'
	| 'normalizedAreaTooltip'
	| 'normalizedBar'
	| 'normalizedBarTooltip'
	| 'normalizedColumn'
	| 'normalizedColumnTooltip'
	| 'noRowsToShow'
	| 'notBlank'
	| 'notContains'
	| 'notEqual'
	| 'november'
	| 'number'
	| 'numberFilter'
	| 'october'
	| 'of'
	| 'offset'
	| 'offsets'
	| 'orCondition'
	| 'padding'
	| 'page'
	| 'pageLastRowUnknown'
	| 'pageSizeSelectorLabel'
	| 'paired'
	| 'paste'
	| 'pie'
	| 'pieChart'
	| 'pieGroup'
	| 'pieTooltip'
	| 'pinColumn'
	| 'pinLeft'
	| 'pinRight'
	| 'pivotChart'
	| 'pivotChartAndPivotMode'
	| 'pivotChartRequiresPivotMode'
	| 'pivotChartTitle'
	| 'pivotColumnGroupTotals'
	| 'pivotColumnsEmptyMessage'
	| 'pivotMode'
	| 'pivots'
	| 'position'
	| 'predefined'
	| 'previousPage'
	| 'rangeChartTitle'
	| 'removeFromLabels'
	| 'removeFromValues'
	| 'resetColumns'
	| 'resetFilter'
	| 'right'
	| 'rowDragRow'
	| 'rowDragRows'
	| 'rowGroupColumnsEmptyMessage'
	| 'scatter'
	| 'scatterGroup'
	| 'scatterTooltip'
	| 'searchOoo'
	| 'secondaryAxis'
	| 'selectAll'
	| 'selectAllSearchResults'
	| 'selectedRows'
	| 'september'
	| 'series'
	| 'seriesChartType'
	| 'seriesType'
	| 'setFilter'
	| 'settings'
	| 'shadow'
	| 'size'
	| 'sortAscending'
	| 'sortDescending'
	| 'sortUnSort'
	| 'spacing'
	| 'stackedArea'
	| 'stackedAreaTooltip'
	| 'stackedBar'
	| 'stackedBarTooltip'
	| 'stackedColumn'
	| 'stackedColumnTooltip'
	| 'startsWith'
	| 'strokeOpacity'
	| 'strokeWidth'
	| 'sum'
	| 'textFilter'
	| 'thickness'
	| 'thousandSeparator'
	| 'ticks'
	| 'time'
	| 'title'
	| 'titlePlaceholder'
	| 'to'
	| 'tooltips'
	| 'top'
	| 'totalAndFilteredRows'
	| 'totalRows'
	| 'true'
	| 'ungroupAll'
	| 'ungroupBy'
	| 'valueAggregation'
	| 'valueColumnsEmptyMessage'
	| 'values'
	| 'width'
	| 'xOffset'
	| 'xRotation'
	| 'xType'
	| 'xyChart'
	| 'xyValues'
	| 'yOffset'
	| 'yRotation';

/**
 * Wrapper class to be able to request local labels
 */
@shUseTranslation('shAgGrid', (lang) => import(`../../i18n/${lang}`))
class AgGridLabelAccessor {
	public static getLabel(translocoService: TranslocoService, agGridLabel: AgGridLabelKey): string {
		const label = AgGridLabelAccessor.labelLookup(translocoService, agGridLabel);
		if (label !== undefined) {
			return label;
		}
		return `!!! ${agGridLabel} !!! Missing AgGrid label mapping`;
	}

	/**
	 * Externalization of label lookup so compiler will detect label keys missing in switch/case
	 */
	private static labelLookup(translocoService: TranslocoService, agGridLabel: AgGridLabelKey): string {
		switch (agGridLabel) {
			case 'addCurrentSelectionToFilter':
				return translocoService.translate('shAgGrid.ag-grid.addCurrentSelectionToFilter');
			case 'addToLabels':
				return translocoService.translate('shAgGrid.ag-grid.addToLabels');
			case 'addToValues':
				return translocoService.translate('shAgGrid.ag-grid.addToValues');
			case 'advancedFilterAnd':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterAnd');
			case 'advancedFilterApply':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterApply');
			case 'advancedFilterBlank':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBlank');
			case 'advancedFilterBuilder':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilder');
			case 'advancedFilterBuilderAddButtonTooltip':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderAddButtonTooltip');
			case 'advancedFilterBuilderAddCondition':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderAddCondition');
			case 'advancedFilterBuilderAddJoin':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderAddJoin');
			case 'advancedFilterBuilderApply':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderApply');
			case 'advancedFilterBuilderCancel':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderCancel');
			case 'advancedFilterBuilderEnterValue':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderEnterValue');
			case 'advancedFilterBuilderMoveDownButtonTooltip':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderMoveDownButtonTooltip');
			case 'advancedFilterBuilderMoveUpButtonTooltip':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderMoveUpButtonTooltip');
			case 'advancedFilterBuilderRemoveButtonTooltip':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderRemoveButtonTooltip');
			case 'advancedFilterBuilderSelectColumn':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderSelectColumn');
			case 'advancedFilterBuilderSelectOption':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderSelectOption');
			case 'advancedFilterBuilderTitle':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderTitle');
			case 'advancedFilterBuilderValidationAlreadyApplied':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderValidationAlreadyApplied');
			case 'advancedFilterBuilderValidationEnterValue':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderValidationEnterValue');
			case 'advancedFilterBuilderValidationIncomplete':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderValidationIncomplete');
			case 'advancedFilterBuilderValidationSelectColumn':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderValidationSelectColumn');
			case 'advancedFilterBuilderValidationSelectOption':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterBuilderValidationSelectOption');
			case 'advancedFilterContains':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterContains');
			case 'advancedFilterEndsWith':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterEndsWith');
			case 'advancedFilterEquals':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterEquals');
			case 'advancedFilterFalse':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterFalse');
			case 'advancedFilterGreaterThan':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterGreaterThan');
			case 'advancedFilterGreaterThanOrEqual':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterGreaterThanOrEqual');
			case 'advancedFilterLessThan':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterLessThan');
			case 'advancedFilterLessThanOrEqual':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterLessThanOrEqual');
			case 'advancedFilterNotBlank':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterNotBlank');
			case 'advancedFilterNotContains':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterNotContains');
			case 'advancedFilterNotEqual':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterNotEqual');
			case 'advancedFilterOr':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterOr');
			case 'advancedFilterStartsWith':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterStartsWith');
			case 'advancedFilterTextEquals':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterTextEquals');
			case 'advancedFilterTextNotEqual':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterTextNotEqual');
			case 'advancedFilterTrue':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterTrue');
			case 'advancedFilterValidationExtraEndBracket':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationExtraEndBracket');
			case 'advancedFilterValidationInvalidColumn':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationInvalidColumn');
			case 'advancedFilterValidationInvalidDate':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationInvalidDate');
			case 'advancedFilterValidationInvalidJoinOperator':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationInvalidJoinOperator');
			case 'advancedFilterValidationInvalidOption':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationInvalidOption');
			case 'advancedFilterValidationJoinOperatorMismatch':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationJoinOperatorMismatch');
			case 'advancedFilterValidationMessage':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMessage');
			case 'advancedFilterValidationMessageAtEnd':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMessageAtEnd');
			case 'advancedFilterValidationMissingColumn':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingColumn');
			case 'advancedFilterValidationMissingCondition':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingCondition');
			case 'advancedFilterValidationMissingEndBracket':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingEndBracket');
			case 'advancedFilterValidationMissingOption':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingOption');
			case 'advancedFilterValidationMissingQuote':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingQuote');
			case 'advancedFilterValidationMissingValue':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationMissingValue');
			case 'advancedFilterValidationNotANumber':
				return translocoService.translate('shAgGrid.ag-grid.advancedFilterValidationNotANumber');
			case 'andCondition':
				return translocoService.translate('shAgGrid.ag-grid.andCondition');
			case 'applyFilter':
				return translocoService.translate('shAgGrid.ag-grid.applyFilter');
			case 'april':
				return translocoService.translate('shAgGrid.ag-grid.april');
			case 'area':
				return translocoService.translate('shAgGrid.ag-grid.area');
			case 'areaChart':
				return translocoService.translate('shAgGrid.ag-grid.areaChart');
			case 'AreaColumnCombo':
				return translocoService.translate('shAgGrid.ag-grid.AreaColumnCombo');
			case 'areaColumnComboTooltip':
				return translocoService.translate('shAgGrid.ag-grid.areaColumnComboTooltip');
			case 'areaGroup':
				return translocoService.translate('shAgGrid.ag-grid.areaGroup');
			case 'ariaAdvancedFilterBuilderColumn':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderColumn');
			case 'ariaAdvancedFilterBuilderFilterItem':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderFilterItem');
			case 'ariaAdvancedFilterBuilderGroupItem':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderGroupItem');
			case 'ariaAdvancedFilterBuilderItem':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderItem');
			case 'ariaAdvancedFilterBuilderItemValidation':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderItemValidation');
			case 'ariaAdvancedFilterBuilderJoinOperator':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderJoinOperator');
			case 'ariaAdvancedFilterBuilderList':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderList');
			case 'ariaAdvancedFilterBuilderOption':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderOption');
			case 'ariaAdvancedFilterBuilderValueP':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterBuilderValueP');
			case 'ariaAdvancedFilterInput':
				return translocoService.translate('shAgGrid.ag-grid.ariaAdvancedFilterInput');
			case 'ariaChecked':
				return translocoService.translate('shAgGrid.ag-grid.ariaChecked');
			case 'ariaColumn':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumn');
			case 'ariaColumnFiltered':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumnFiltered');
			case 'ariaColumnGroup':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumnGroup');
			case 'ariaColumnList':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumnList');
			case 'ariaColumnPanelList':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumnPanelList');
			case 'ariaColumnSelectAll':
				return translocoService.translate('shAgGrid.ag-grid.ariaColumnSelectAll');
			case 'ariaDateFilterInput':
				return translocoService.translate('shAgGrid.ag-grid.ariaDateFilterInput');
			case 'ariaDefaultListName':
				return translocoService.translate('shAgGrid.ag-grid.ariaDefaultListName');
			case 'ariaDropZoneColumnComponentAggFuncSeparator':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnComponentAggFuncSeparator');
			case 'ariaDropZoneColumnComponentDescription':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnComponentDescription');
			case 'ariaDropZoneColumnComponentSortAscending':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnComponentSortAscending');
			case 'ariaDropZoneColumnComponentSortDescending':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnComponentSortDescending');
			case 'ariaDropZoneColumnGroupItemDescription':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnGroupItemDescription');
			case 'ariaDropZoneColumnValueItemDescription':
				return translocoService.translate('shAgGrid.ag-grid.ariaDropZoneColumnValueItemDescription');
			case 'ariaFilterColumn':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterColumn');
			case 'ariaFilterColumnsInput':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterColumnsInput');
			case 'ariaFilterFromValue':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterFromValue');
			case 'ariaFilteringOperator':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilteringOperator');
			case 'ariaFilterInput':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterInput');
			case 'ariaFilterList':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterList');
			case 'ariaFilterMenuOpen':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterMenuOpen');
			case 'ariaFilterPanelList':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterPanelList');
			case 'ariaFilterToValue':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterToValue');
			case 'ariaFilterValue':
				return translocoService.translate('shAgGrid.ag-grid.ariaFilterValue');
			case 'ariaHidden':
				return translocoService.translate('shAgGrid.ag-grid.ariaHidden');
			case 'ariaIndeterminate':
				return translocoService.translate('shAgGrid.ag-grid.ariaIndeterminate');
			case 'ariaInputEditor':
				return translocoService.translate('shAgGrid.ag-grid.ariaInputEditor');
			case 'ariaLabelAdvancedFilterAutocomplete':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAdvancedFilterAutocomplete');
			case 'ariaLabelAdvancedFilterBuilderAddField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAdvancedFilterBuilderAddField');
			case 'ariaLabelAdvancedFilterBuilderColumnSelectField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAdvancedFilterBuilderColumnSelectField');
			case 'ariaLabelAdvancedFilterBuilderJoinSelectField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAdvancedFilterBuilderJoinSelectField');
			case 'ariaLabelAdvancedFilterBuilderOptionSelectField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAdvancedFilterBuilderOptionSelectField');
			case 'ariaLabelAggregationFunction':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelAggregationFunction');
			case 'ariaLabelCellEditor':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelCellEditor');
			case 'ariaLabelColumnFilter':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelColumnFilter');
			case 'ariaLabelColumnMenu':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelColumnMenu');
			case 'ariaLabelContextMenu':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelContextMenu');
			case 'ariaLabelDialog':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelDialog');
			case 'ariaLabelRichSelectDeleteSelection':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelRichSelectDeleteSelection');
			case 'ariaLabelRichSelectDeselectAllItems':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelRichSelectDeselectAllItems');
			case 'ariaLabelRichSelectField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelRichSelectField');
			case 'ariaLabelRichSelectToggleSelection':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelRichSelectToggleSelection');
			case 'ariaLabelSelectField':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelSelectField');
			case 'ariaLabelSubMenu':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelSubMenu');
			case 'ariaLabelTooltip':
				return translocoService.translate('shAgGrid.ag-grid.ariaLabelTooltip');
			case 'ariaMenuColumn':
				return translocoService.translate('shAgGrid.ag-grid.ariaMenuColumn');
			case 'ariaPageSizeSelectorLabel':
				return translocoService.translate('shAgGrid.ag-grid.ariaPageSizeSelectorLabel');
			case 'ariaPivotDropZonePanelLabel':
				return translocoService.translate('shAgGrid.ag-grid.ariaPivotDropZonePanelLabel');
			case 'ariaRowDeselect':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowDeselect');
			case 'ariaRowGroupDropZonePanelLabel':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowGroupDropZonePanelLabel');
			case 'ariaRowSelect':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowSelect');
			case 'ariaRowSelectAll':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowSelectAll');
			case 'ariaRowSelectionDisabled':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowSelectionDisabled');
			case 'ariaRowToggleSelection':
				return translocoService.translate('shAgGrid.ag-grid.ariaRowToggleSelection');
			case 'ariaSearch':
				return translocoService.translate('shAgGrid.ag-grid.ariaSearch');
			case 'ariaSearchFilterValues':
				return translocoService.translate('shAgGrid.ag-grid.ariaSearchFilterValues');
			case 'ariaSortableColumn':
				return translocoService.translate('shAgGrid.ag-grid.ariaSortableColumn');
			case 'ariaToggleCellValue':
				return translocoService.translate('shAgGrid.ag-grid.ariaToggleCellValue');
			case 'ariaToggleVisibility':
				return translocoService.translate('shAgGrid.ag-grid.ariaToggleVisibility');
			case 'ariaUnchecked':
				return translocoService.translate('shAgGrid.ag-grid.ariaUnchecked');
			case 'ariaValuesDropZonePanelLabel':
				return translocoService.translate('shAgGrid.ag-grid.ariaValuesDropZonePanelLabel');
			case 'ariaVisible':
				return translocoService.translate('shAgGrid.ag-grid.ariaVisible');
			case 'august':
				return translocoService.translate('shAgGrid.ag-grid.august');
			case 'automatic':
				return translocoService.translate('shAgGrid.ag-grid.automatic');
			case 'autoRotate':
				return translocoService.translate('shAgGrid.ag-grid.autoRotate');
			case 'autosizeAllColumns':
				return translocoService.translate('shAgGrid.ag-grid.autosizeAllColumns');
			case 'autosizeThisColumn':
				return translocoService.translate('shAgGrid.ag-grid.autosizeThisColumn');
			case 'avg':
				return translocoService.translate('shAgGrid.ag-grid.avg');
			case 'axis':
				return translocoService.translate('shAgGrid.ag-grid.axis');
			case 'background':
				return translocoService.translate('shAgGrid.ag-grid.background');
			case 'barChart':
				return translocoService.translate('shAgGrid.ag-grid.barChart');
			case 'barGroup':
				return translocoService.translate('shAgGrid.ag-grid.barGroup');
			case 'blank':
				return translocoService.translate('shAgGrid.ag-grid.blank');
			case 'blanks':
				return translocoService.translate('shAgGrid.ag-grid.blanks');
			case 'blur':
				return translocoService.translate('shAgGrid.ag-grid.blur');
			case 'bold':
				return translocoService.translate('shAgGrid.ag-grid.bold');
			case 'boldItalic':
				return translocoService.translate('shAgGrid.ag-grid.boldItalic');
			case 'bottom':
				return translocoService.translate('shAgGrid.ag-grid.bottom');
			case 'bubble':
				return translocoService.translate('shAgGrid.ag-grid.bubble');
			case 'bubbleTooltip':
				return translocoService.translate('shAgGrid.ag-grid.bubbleTooltip');
			case 'callout':
				return translocoService.translate('shAgGrid.ag-grid.callout');
			case 'cancelFilter':
				return translocoService.translate('shAgGrid.ag-grid.cancelFilter');
			case 'categories':
				return translocoService.translate('shAgGrid.ag-grid.categories');
			case 'category':
				return translocoService.translate('shAgGrid.ag-grid.category');
			case 'chart':
				return translocoService.translate('shAgGrid.ag-grid.chart');
			case 'chartDownloadToolbarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.chartDownloadToolbarTooltip');
			case 'chartLinkToolbarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.chartLinkToolbarTooltip');
			case 'chartRange':
				return translocoService.translate('shAgGrid.ag-grid.chartRange');
			case 'chartSettingsToolbarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.chartSettingsToolbarTooltip');
			case 'chartUnlinkToolbarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.chartUnlinkToolbarTooltip');
			case 'chooseColumns':
				return translocoService.translate('shAgGrid.ag-grid.chooseColumns');
			case 'clearFilter':
				return translocoService.translate('shAgGrid.ag-grid.clearFilter');
			case 'collapseAll':
				return translocoService.translate('shAgGrid.ag-grid.collapseAll');
			case 'color':
				return translocoService.translate('shAgGrid.ag-grid.color');
			case 'columnChart':
				return translocoService.translate('shAgGrid.ag-grid.columnChart');
			case 'columnChooser':
				return translocoService.translate('shAgGrid.ag-grid.columnChooser');
			case 'columnGroup':
				return translocoService.translate('shAgGrid.ag-grid.columnGroup');
			case 'columnLineCombo':
				return translocoService.translate('shAgGrid.ag-grid.columnLineCombo');
			case 'columnLineComboTooltip':
				return translocoService.translate('shAgGrid.ag-grid.columnLineComboTooltip');
			case 'columns':
				return translocoService.translate('shAgGrid.ag-grid.columns');
			case 'combinationChart':
				return translocoService.translate('shAgGrid.ag-grid.combinationChart');
			case 'combinationGroup':
				return translocoService.translate('shAgGrid.ag-grid.combinationGroup');
			case 'contains':
				return translocoService.translate('shAgGrid.ag-grid.contains');
			case 'copy':
				return translocoService.translate('shAgGrid.ag-grid.copy');
			case 'copyWithGroupHeaders':
				return translocoService.translate('shAgGrid.ag-grid.copyWithGroupHeaders');
			case 'copyWithHeaders':
				return translocoService.translate('shAgGrid.ag-grid.copyWithHeaders');
			case 'count':
				return translocoService.translate('shAgGrid.ag-grid.count');
			case 'csvExport':
				return translocoService.translate('shAgGrid.ag-grid.csvExport');
			case 'ctrlC':
				return translocoService.translate('shAgGrid.ag-grid.ctrlC');
			case 'ctrlV':
				return translocoService.translate('shAgGrid.ag-grid.ctrlV');
			case 'ctrlX':
				return translocoService.translate('shAgGrid.ag-grid.ctrlX');
			case 'customComboTooltip':
				return translocoService.translate('shAgGrid.ag-grid.customComboTooltip');
			case 'cut':
				return translocoService.translate('shAgGrid.ag-grid.cut');
			case 'data':
				return translocoService.translate('shAgGrid.ag-grid.data');
			case 'dateFilter':
				return translocoService.translate('shAgGrid.ag-grid.dateFilter');
			case 'dateFormatOoo':
				return translocoService.translate('shAgGrid.ag-grid.dateFormatOoo');
			case 'december':
				return translocoService.translate('shAgGrid.ag-grid.december');
			case 'decimalSeparator':
				return translocoService.translate('shAgGrid.ag-grid.decimalSeparator');
			case 'defaultCategory':
				return translocoService.translate('shAgGrid.ag-grid.defaultCategory');
			case 'doughnut':
				return translocoService.translate('shAgGrid.ag-grid.doughnut');
			case 'doughnutTooltip':
				return translocoService.translate('shAgGrid.ag-grid.doughnutTooltip');
			case 'empty':
				return translocoService.translate('shAgGrid.ag-grid.empty');
			case 'enabled':
				return translocoService.translate('shAgGrid.ag-grid.enabled');
			case 'endsWith':
				return translocoService.translate('shAgGrid.ag-grid.endsWith');
			case 'equals':
				return translocoService.translate('shAgGrid.ag-grid.equals');
			case 'excelExport':
				return translocoService.translate('shAgGrid.ag-grid.excelExport');
			case 'expandAll':
				return translocoService.translate('shAgGrid.ag-grid.expandAll');
			case 'export':
				return translocoService.translate('shAgGrid.ag-grid.export');
			case 'exportSelected':
				return translocoService.translate('shAgGrid.ag-grid.exportSelected');
			case 'false':
				return translocoService.translate('shAgGrid.ag-grid.false');
			case 'february':
				return translocoService.translate('shAgGrid.ag-grid.february');
			case 'fillOpacity':
				return translocoService.translate('shAgGrid.ag-grid.fillOpacity');
			case 'filteredRows':
				return translocoService.translate('shAgGrid.ag-grid.filteredRows');
			case 'filterOoo':
				return translocoService.translate('shAgGrid.ag-grid.filterOoo');
			case 'filters':
				return translocoService.translate('shAgGrid.ag-grid.filters');
			case 'first':
				return translocoService.translate('shAgGrid.ag-grid.first');
			case 'firstPage':
				return translocoService.translate('shAgGrid.ag-grid.firstPage');
			case 'font':
				return translocoService.translate('shAgGrid.ag-grid.font');
			case 'format':
				return translocoService.translate('shAgGrid.ag-grid.format');
			case 'greaterThan':
				return translocoService.translate('shAgGrid.ag-grid.greaterThan');
			case 'greaterThanOrEqual':
				return translocoService.translate('shAgGrid.ag-grid.greaterThanOrEqual');
			case 'group':
				return translocoService.translate('shAgGrid.ag-grid.group');
			case 'groupBy':
				return translocoService.translate('shAgGrid.ag-grid.groupBy');
			case 'groupedAreaTooltip':
				return translocoService.translate('shAgGrid.ag-grid.groupedAreaTooltip');
			case 'groupedBar':
				return translocoService.translate('shAgGrid.ag-grid.groupedBar');
			case 'groupedBarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.groupedBarTooltip');
			case 'groupedColumn':
				return translocoService.translate('shAgGrid.ag-grid.groupedColumn');
			case 'groupedColumnTooltip':
				return translocoService.translate('shAgGrid.ag-grid.groupedColumnTooltip');
			case 'groupFilterSelect':
				return translocoService.translate('shAgGrid.ag-grid.groupFilterSelect');
			case 'groups':
				return translocoService.translate('shAgGrid.ag-grid.groups');
			case 'height':
				return translocoService.translate('shAgGrid.ag-grid.height');
			case 'histogramBinCount':
				return translocoService.translate('shAgGrid.ag-grid.histogramBinCount');
			case 'histogramChart':
				return translocoService.translate('shAgGrid.ag-grid.histogramChart');
			case 'histogramFrequency':
				return translocoService.translate('shAgGrid.ag-grid.histogramFrequency');
			case 'histogramGroup':
				return translocoService.translate('shAgGrid.ag-grid.histogramGroup');
			case 'histogramTooltip':
				return translocoService.translate('shAgGrid.ag-grid.histogramTooltip');
			case 'inRange':
				return translocoService.translate('shAgGrid.ag-grid.inRange');
			case 'inRangeEnd':
				return translocoService.translate('shAgGrid.ag-grid.inRangeEnd');
			case 'inRangeStart':
				return translocoService.translate('shAgGrid.ag-grid.inRangeStart');
			case 'invalidDate':
				return translocoService.translate('shAgGrid.ag-grid.invalidDate');
			case 'invalidNumber':
				return translocoService.translate('shAgGrid.ag-grid.invalidNumber');
			case 'italic':
				return translocoService.translate('shAgGrid.ag-grid.italic');
			case 'itemPaddingX':
				return translocoService.translate('shAgGrid.ag-grid.itemPaddingX');
			case 'itemPaddingY':
				return translocoService.translate('shAgGrid.ag-grid.itemPaddingY');
			case 'itemSpacing':
				return translocoService.translate('shAgGrid.ag-grid.itemSpacing');
			case 'january':
				return translocoService.translate('shAgGrid.ag-grid.january');
			case 'july':
				return translocoService.translate('shAgGrid.ag-grid.july');
			case 'june':
				return translocoService.translate('shAgGrid.ag-grid.june');
			case 'labels':
				return translocoService.translate('shAgGrid.ag-grid.labels');
			case 'last':
				return translocoService.translate('shAgGrid.ag-grid.last');
			case 'lastPage':
				return translocoService.translate('shAgGrid.ag-grid.lastPage');
			case 'layoutHorizontalSpacing':
				return translocoService.translate('shAgGrid.ag-grid.layoutHorizontalSpacing');
			case 'layoutVerticalSpacing':
				return translocoService.translate('shAgGrid.ag-grid.layoutVerticalSpacing');
			case 'left':
				return translocoService.translate('shAgGrid.ag-grid.left');
			case 'legend':
				return translocoService.translate('shAgGrid.ag-grid.legend');
			case 'length':
				return translocoService.translate('shAgGrid.ag-grid.length');
			case 'lessThan':
				return translocoService.translate('shAgGrid.ag-grid.lessThan');
			case 'lessThanOrEqual':
				return translocoService.translate('shAgGrid.ag-grid.lessThanOrEqual');
			case 'line':
				return translocoService.translate('shAgGrid.ag-grid.line');
			case 'lineDash':
				return translocoService.translate('shAgGrid.ag-grid.lineDash');
			case 'lineGroup':
				return translocoService.translate('shAgGrid.ag-grid.lineGroup');
			case 'lineTooltip':
				return translocoService.translate('shAgGrid.ag-grid.lineTooltip');
			case 'lineWidth':
				return translocoService.translate('shAgGrid.ag-grid.lineWidth');
			case 'loadingError':
				return translocoService.translate('shAgGrid.ag-grid.loadingError');
			case 'loadingOoo':
				return translocoService.translate('shAgGrid.ag-grid.loadingOoo');
			case 'march':
				return translocoService.translate('shAgGrid.ag-grid.march');
			case 'markerPadding':
				return translocoService.translate('shAgGrid.ag-grid.markerPadding');
			case 'markers':
				return translocoService.translate('shAgGrid.ag-grid.markers');
			case 'markerSize':
				return translocoService.translate('shAgGrid.ag-grid.markerSize');
			case 'markerStroke':
				return translocoService.translate('shAgGrid.ag-grid.markerStroke');
			case 'max':
				return translocoService.translate('shAgGrid.ag-grid.max');
			case 'maxSize':
				return translocoService.translate('shAgGrid.ag-grid.maxSize');
			case 'may':
				return translocoService.translate('shAgGrid.ag-grid.may');
			case 'min':
				return translocoService.translate('shAgGrid.ag-grid.min');
			case 'minSize':
				return translocoService.translate('shAgGrid.ag-grid.minSize');
			case 'more':
				return translocoService.translate('shAgGrid.ag-grid.more');
			case 'navigator':
				return translocoService.translate('shAgGrid.ag-grid.navigator');
			case 'nextPage':
				return translocoService.translate('shAgGrid.ag-grid.nextPage');
			case 'noAggregation':
				return translocoService.translate('shAgGrid.ag-grid.noAggregation');
			case 'noDataToChart':
				return translocoService.translate('shAgGrid.ag-grid.noDataToChart');
			case 'noMatches':
				return translocoService.translate('shAgGrid.ag-grid.noMatches');
			case 'none':
				return translocoService.translate('shAgGrid.ag-grid.none');
			case 'noPin':
				return translocoService.translate('shAgGrid.ag-grid.noPin');
			case 'normal':
				return translocoService.translate('shAgGrid.ag-grid.normal');
			case 'normalizedArea':
				return translocoService.translate('shAgGrid.ag-grid.normalizedArea');
			case 'normalizedAreaTooltip':
				return translocoService.translate('shAgGrid.ag-grid.normalizedAreaTooltip');
			case 'normalizedBar':
				return translocoService.translate('shAgGrid.ag-grid.normalizedBar');
			case 'normalizedBarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.normalizedBarTooltip');
			case 'normalizedColumn':
				return translocoService.translate('shAgGrid.ag-grid.normalizedColumn');
			case 'normalizedColumnTooltip':
				return translocoService.translate('shAgGrid.ag-grid.normalizedColumnTooltip');
			case 'noRowsToShow':
				return translocoService.translate('shAgGrid.ag-grid.noRowsToShow');
			case 'notBlank':
				return translocoService.translate('shAgGrid.ag-grid.notBlank');
			case 'notContains':
				return translocoService.translate('shAgGrid.ag-grid.notContains');
			case 'notEqual':
				return translocoService.translate('shAgGrid.ag-grid.notEqual');
			case 'november':
				return translocoService.translate('shAgGrid.ag-grid.november');
			case 'number':
				return translocoService.translate('shAgGrid.ag-grid.number');
			case 'numberFilter':
				return translocoService.translate('shAgGrid.ag-grid.numberFilter');
			case 'october':
				return translocoService.translate('shAgGrid.ag-grid.october');
			case 'of':
				return translocoService.translate('shAgGrid.ag-grid.of');
			case 'offset':
				return translocoService.translate('shAgGrid.ag-grid.offset');
			case 'offsets':
				return translocoService.translate('shAgGrid.ag-grid.offsets');
			case 'orCondition':
				return translocoService.translate('shAgGrid.ag-grid.orCondition');
			case 'padding':
				return translocoService.translate('shAgGrid.ag-grid.padding');
			case 'page':
				return translocoService.translate('shAgGrid.ag-grid.page');
			case 'pageLastRowUnknown':
				return translocoService.translate('shAgGrid.ag-grid.pageLastRowUnknown');
			case 'pageSizeSelectorLabel':
				return translocoService.translate('shAgGrid.ag-grid.pageSizeSelectorLabel');
			case 'paired':
				return translocoService.translate('shAgGrid.ag-grid.paired');
			case 'paste':
				return translocoService.translate('shAgGrid.ag-grid.paste');
			case 'pie':
				return translocoService.translate('shAgGrid.ag-grid.pie');
			case 'pieChart':
				return translocoService.translate('shAgGrid.ag-grid.pieChart');
			case 'pieGroup':
				return translocoService.translate('shAgGrid.ag-grid.pieGroup');
			case 'pieTooltip':
				return translocoService.translate('shAgGrid.ag-grid.pieTooltip');
			case 'pinColumn':
				return translocoService.translate('shAgGrid.ag-grid.pinColumn');
			case 'pinLeft':
				return translocoService.translate('shAgGrid.ag-grid.pinLeft');
			case 'pinRight':
				return translocoService.translate('shAgGrid.ag-grid.pinRight');
			case 'pivotChart':
				return translocoService.translate('shAgGrid.ag-grid.pivotChart');
			case 'pivotChartAndPivotMode':
				return translocoService.translate('shAgGrid.ag-grid.pivotChartAndPivotMode');
			case 'pivotChartRequiresPivotMode':
				return translocoService.translate('shAgGrid.ag-grid.pivotChartRequiresPivotMode');
			case 'pivotChartTitle':
				return translocoService.translate('shAgGrid.ag-grid.pivotChartTitle');
			case 'pivotColumnGroupTotals':
				return translocoService.translate('shAgGrid.ag-grid.pivotColumnGroupTotals');
			case 'pivotColumnsEmptyMessage':
				return translocoService.translate('shAgGrid.ag-grid.pivotColumnsEmptyMessage');
			case 'pivotMode':
				return translocoService.translate('shAgGrid.ag-grid.pivotMode');
			case 'pivots':
				return translocoService.translate('shAgGrid.ag-grid.pivots');
			case 'position':
				return translocoService.translate('shAgGrid.ag-grid.position');
			case 'predefined':
				return translocoService.translate('shAgGrid.ag-grid.predefined');
			case 'previousPage':
				return translocoService.translate('shAgGrid.ag-grid.previousPage');
			case 'rangeChartTitle':
				return translocoService.translate('shAgGrid.ag-grid.rangeChartTitle');
			case 'removeFromLabels':
				return translocoService.translate('shAgGrid.ag-grid.removeFromLabels');
			case 'removeFromValues':
				return translocoService.translate('shAgGrid.ag-grid.removeFromValues');
			case 'resetColumns':
				return translocoService.translate('shAgGrid.ag-grid.resetColumns');
			case 'resetFilter':
				return translocoService.translate('shAgGrid.ag-grid.resetFilter');
			case 'right':
				return translocoService.translate('shAgGrid.ag-grid.right');
			case 'rowDragRow':
				return translocoService.translate('shAgGrid.ag-grid.rowDragRow');
			case 'rowDragRows':
				return translocoService.translate('shAgGrid.ag-grid.rowDragRows');
			case 'rowGroupColumnsEmptyMessage':
				return translocoService.translate('shAgGrid.ag-grid.rowGroupColumnsEmptyMessage');
			case 'scatter':
				return translocoService.translate('shAgGrid.ag-grid.scatter');
			case 'scatterGroup':
				return translocoService.translate('shAgGrid.ag-grid.scatterGroup');
			case 'scatterTooltip':
				return translocoService.translate('shAgGrid.ag-grid.scatterTooltip');
			case 'searchOoo':
				return translocoService.translate('shAgGrid.ag-grid.searchOoo');
			case 'secondaryAxis':
				return translocoService.translate('shAgGrid.ag-grid.secondaryAxis');
			case 'selectAll':
				return translocoService.translate('shAgGrid.ag-grid.selectAll');
			case 'selectAllSearchResults':
				return translocoService.translate('shAgGrid.ag-grid.selectAllSearchResults');
			case 'selectedRows':
				return translocoService.translate('shAgGrid.ag-grid.selectedRows');
			case 'september':
				return translocoService.translate('shAgGrid.ag-grid.september');
			case 'series':
				return translocoService.translate('shAgGrid.ag-grid.series');
			case 'seriesChartType':
				return translocoService.translate('shAgGrid.ag-grid.seriesChartType');
			case 'seriesType':
				return translocoService.translate('shAgGrid.ag-grid.seriesType');
			case 'setFilter':
				return translocoService.translate('shAgGrid.ag-grid.setFilter');
			case 'settings':
				return translocoService.translate('shAgGrid.ag-grid.settings');
			case 'shadow':
				return translocoService.translate('shAgGrid.ag-grid.shadow');
			case 'size':
				return translocoService.translate('shAgGrid.ag-grid.size');
			case 'sortAscending':
				return translocoService.translate('shAgGrid.ag-grid.sortAscending');
			case 'sortDescending':
				return translocoService.translate('shAgGrid.ag-grid.sortDescending');
			case 'sortUnSort':
				return translocoService.translate('shAgGrid.ag-grid.sortUnSort');
			case 'spacing':
				return translocoService.translate('shAgGrid.ag-grid.spacing');
			case 'stackedArea':
				return translocoService.translate('shAgGrid.ag-grid.stackedArea');
			case 'stackedAreaTooltip':
				return translocoService.translate('shAgGrid.ag-grid.stackedAreaTooltip');
			case 'stackedBar':
				return translocoService.translate('shAgGrid.ag-grid.stackedBar');
			case 'stackedBarTooltip':
				return translocoService.translate('shAgGrid.ag-grid.stackedBarTooltip');
			case 'stackedColumn':
				return translocoService.translate('shAgGrid.ag-grid.stackedColumn');
			case 'stackedColumnTooltip':
				return translocoService.translate('shAgGrid.ag-grid.stackedColumnTooltip');
			case 'startsWith':
				return translocoService.translate('shAgGrid.ag-grid.startsWith');
			case 'strokeOpacity':
				return translocoService.translate('shAgGrid.ag-grid.strokeOpacity');
			case 'strokeWidth':
				return translocoService.translate('shAgGrid.ag-grid.strokeWidth');
			case 'sum':
				return translocoService.translate('shAgGrid.ag-grid.sum');
			case 'textFilter':
				return translocoService.translate('shAgGrid.ag-grid.textFilter');
			case 'thickness':
				return translocoService.translate('shAgGrid.ag-grid.thickness');
			case 'thousandSeparator':
				return translocoService.translate('shAgGrid.ag-grid.thousandSeparator');
			case 'ticks':
				return translocoService.translate('shAgGrid.ag-grid.ticks');
			case 'time':
				return translocoService.translate('shAgGrid.ag-grid.time');
			case 'title':
				return translocoService.translate('shAgGrid.ag-grid.title');
			case 'titlePlaceholder':
				return translocoService.translate('shAgGrid.ag-grid.titlePlaceholder');
			case 'to':
				return translocoService.translate('shAgGrid.ag-grid.to');
			case 'tooltips':
				return translocoService.translate('shAgGrid.ag-grid.tooltips');
			case 'top':
				return translocoService.translate('shAgGrid.ag-grid.top');
			case 'totalAndFilteredRows':
				return translocoService.translate('shAgGrid.ag-grid.totalAndFilteredRows');
			case 'totalRows':
				return translocoService.translate('shAgGrid.ag-grid.totalRows');
			case 'true':
				return translocoService.translate('shAgGrid.ag-grid.true');
			case 'ungroupAll':
				return translocoService.translate('shAgGrid.ag-grid.ungroupAll');
			case 'ungroupBy':
				return translocoService.translate('shAgGrid.ag-grid.ungroupBy');
			case 'valueAggregation':
				return translocoService.translate('shAgGrid.ag-grid.valueAggregation');
			case 'valueColumnsEmptyMessage':
				return translocoService.translate('shAgGrid.ag-grid.valueColumnsEmptyMessage');
			case 'values':
				return translocoService.translate('shAgGrid.ag-grid.values');
			case 'width':
				return translocoService.translate('shAgGrid.ag-grid.width');
			case 'xOffset':
				return translocoService.translate('shAgGrid.ag-grid.xOffset');
			case 'xRotation':
				return translocoService.translate('shAgGrid.ag-grid.xRotation');
			case 'xType':
				return translocoService.translate('shAgGrid.ag-grid.xType');
			case 'xyChart':
				return translocoService.translate('shAgGrid.ag-grid.xyChart');
			case 'xyValues':
				return translocoService.translate('shAgGrid.ag-grid.xyValues');
			case 'yOffset':
				return translocoService.translate('shAgGrid.ag-grid.yOffset');
			case 'yRotation':
				return translocoService.translate('shAgGrid.ag-grid.yRotation');
		}
	}
}

/**
 * Get AgGrid label text based on the AgGrid label key
 */
export function agGridLabelLookup(translocoService: TranslocoService, agGridLabel: string): string {
	return AgGridLabelAccessor.getLabel(translocoService, <AgGridLabelKey>agGridLabel);
}

/**
 * Get AgGrid label text based on the AgGrid label key (with key name validation)
 * This is the same function as agGridLabelLookup(), only label to get is limited to the defined set of AgGrid label keys
 */
export function getAgGridLabel(translocoService: TranslocoService, agGridLabel: AgGridLabelKey): string {
	return AgGridLabelAccessor.getLabel(translocoService, agGridLabel);
}
